<style scoped>
.coin {
  min-width: 20px;
  min-height: 20px;
}

.large {
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
}

.big {
  min-width: 32px;
  min-height: 32px;
  width: 32px;
  height: 32px;
}

.medium {
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
}
</style>
<template>
    <img
      :onerror="onError"
      :key="key"
      width="20px"
      height="20px"
      class="coin"
      :class="{ large, big, medium }"
      :src="coinUrl"
    />
</template>

<script>
const coinRegExp = new RegExp('.+?(?=\\.|\\s|-|/|_)') // string before '.' or '[space]' or '-' or '/' or '_'
const errorUrl = 'https://capico.app/icons/color/def3.png'

export default {
  props: { symbol: String, large: Boolean, big: Boolean, medium: Boolean },
  computed: {
    coinUrl () {
      const coin = coinRegExp.exec(this.symbol)
        ? coinRegExp.exec(this.symbol)[0]
        : this.symbol

      if (coin) {
        return (
          'https://capico.app/icons/color/' + coin.toLowerCase() + '.png'
        )
      } else {
        return errorUrl
      }
    },
    onError () {
      return `this.onerror=null;this.src='${errorUrl}'`
    },
    key () {
      return `${this.symbol}_${Math.random()}`
    }
  }
}
</script>
